import { updateWaitingRoomWithToken } from '../../waitingRoom';
import { trackOnCreateOrderError } from './trackOnCreateOrderError';
import { WAITING_ROOM_TOKEN_HEADER } from '../../../api/base';
import { BASE_URL, WAITING_ROOM_PATH, NOT_FOUND } from '../../../constants';
import { retrieveOrderFailureAction } from '../../app';
import { refreshEventAndTickets } from '../../initialize';
import { joinPath } from '@eventbrite/path-utils';
import { push } from 'react-router-redux';

export const handleOnCreateOrderError = (dispatch) => async (error) => {
    trackOnCreateOrderError(error);

    // first, check if the error is an instance of CustomSubmissionError
    if (error && error.extraData) {
        const { response: { status, headers } = {}, parsedError } =
            error.extraData;

        // check if server respond with a redirect and the WR header
        // and save the info into the store and navigate to WR view
        if (status === 307 && headers.has(WAITING_ROOM_TOKEN_HEADER)) {
            dispatch(
                updateWaitingRoomWithToken(
                    headers.get(WAITING_ROOM_TOKEN_HEADER),
                ),
            );
            dispatch(push(joinPath(BASE_URL, WAITING_ROOM_PATH)));

            return;
        }

        // In case of Existing Order, there is a dim chance that the newly created order is not found
        // This will result in a 404 that will be caught here, we'll then notify the user.
        if (status === 404 && parsedError.error === NOT_FOUND) {
            dispatch(retrieveOrderFailureAction(parsedError));
            throw error;
        }
    }
    await dispatch(
        refreshEventAndTickets(null, error, { skipVarnishCache: true }),
    );
    throw error;
};
